exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.price-container[data-v-39349b68]{\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n    border-radius: 20px;\n    background-color: #49B672;\n}\n.discount-wrapper[data-v-39349b68] {\n    margin-right: -0.5rem;\n    margin-left: 0.25rem;\n    border-radius: 20px;\n    background-color: #FFC61A;\n    color: #404040;\n}\n.price-wrapper[data-v-39349b68] {\n    padding-top: 0.125rem;\n    padding-bottom: 0.125rem;\n}\n", ""]);

// exports
